import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/logo.png";

function Footer() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4">
          <Col lg={3} md={6}>
            <Link to={`/${currentLang}`} className="d-inline-block mb-4">
              <img
                src={logo || "/placeholder.svg"}
                alt="Betonbum Logo"
                height="50"
              />
            </Link>
            <p className="text-white-50 mb-4">{t("footer.about")}</p>
            <div className="d-flex gap-3">
              <a
                href="https://www.instagram.com/betonbum/"
                className="social-link"
              >
                <FaInstagram />
              </a>
              <a href="https://wa.me/37120707555" className="social-link">
                <FaWhatsapp />
              </a>
            </div>
          </Col>

          <Col lg={3} md={6}>
            <h5 className="mb-4">{t("footer.quickLinks")}</h5>
            <ul className="footer-links">
              <li>
                <Link to={`/${currentLang}`}>{t("nav.home")}</Link>
              </li>
              <li>
                <Link to={`/${currentLang}/about`}>{t("nav.about")}</Link>
              </li>
              <li>
                <Link to={`/${currentLang}/services`}>{t("nav.services")}</Link>
              </li>
              <li>
                <Link to={`/${currentLang}/projects`}>{t("nav.projects")}</Link>
              </li>
              <li>
                <Link to={`/${currentLang}/contact`}>{t("nav.contact")}</Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h5 className="mb-4">{t("footer.services")}</h5>
            <ul className="footer-links">
              {t("footer.serviceLinks", { returnObjects: true }).map(
                (service, index) => (
                  <li key={index}>
                    <Link to={`/${currentLang}/services`}>{service.title}</Link>
                  </li>
                )
              )}
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h5 className="mb-4">{t("footer.contactUs")}</h5>
            <ul className="contact-info">
              <li>
                <FaMapMarkerAlt className="icon" />
                <span>{t("footer.address")}</span>
              </li>
              <li>
                <a
                  href="tel:+37120707555"
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <FaPhoneAlt className="icon" />
                  <span>{t("footer.phone")}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${t("footer.emailAddress")}`}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <FaEnvelope className="icon" />
                  <span>{t("footer.email")}</span>
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        <div className="border-top border-secondary mt-4 pt-4 text-center text-white-50">
          <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
